import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import {
  changeLockStatus,
  createNewMeasureReportingQuarter,
  createNewRegulationReportingQuarter,
  getAvailableNewQuarters,
  getCurrentQuarters,
} from "../../../server/server";
import { notif } from "../../utils/util";

import { FaLockOpen } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { set } from "date-fns";
import { useNavigate } from "react-router-dom";
import HelpButton from "../../../common/HelpButton";
import HelpPageModal from "../../modals/HelpPageModal";

const ReportingConfig = () => {
  const [availableQuarters, setAvailableQuarters] = useState<string[]>([]);
  const [selectedQuarter, setSelectedQuarter] = useState<string>("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [editingLockHistory, setEditingLockHistory] = useState<any[]>([]);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [historyPage, setHistoryPage] = useState(0);
  const [historyPageSize, setHistoryPageSize] = useState(6);
  const [historyRowCount, setHistoryRowCount] = useState(6);
  const [tabValue, setTabValue] = useState(0);
  const [selectedQuarterID, setSelectedQuarterID] = useState("");

  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogContent, setDialogContent] = useState("");
  const [dialogSubText, setDialogSubText] = useState("");
  const [helpModal, setHelpModal] = useState(false);

  const navigate = useNavigate();

  const getAvailableQuarters = async () => {
    const type = tabValue === 0 ? "regulation" : "measure";
    const resp = await getAvailableNewQuarters(type);

    if (resp.status === 200) {
      setAvailableQuarters(resp.data);
    } else {
      setAvailableQuarters([]);
      notif("Грешка при учитавању расположивих квартала", "error");
    }
  };

  const getCurentQuarters = async () => {
    const type = tabValue === 0 ? "regulation" : "measure";
    const skip = historyPage * historyPageSize;
    const resp = await getCurrentQuarters(type, skip, historyPageSize);

    if (resp.status === 200) {
      const [items, count] = resp.data;
      setEditingLockHistory(items || []);
      setHistoryRowCount(count || 0);
    } else {
      setEditingLockHistory([]);
      setHistoryRowCount(0);
      notif("Грешка при учитавању тренутног квартала", "error");
    }
  };

  const createNewQuarter = async () => {
    const resp =
      tabValue === 0
        ? await createNewRegulationReportingQuarter(selectedQuarter)
        : await createNewMeasureReportingQuarter(selectedQuarter);

    if (resp.status === 201) {
      notif("Успешно креиран нови квартал за извештавање", "success");
      getAvailableQuarters();
      getCurentQuarters();
    } else {
      notif("Грешка при креирању новог квартала за извештавање", "error");
    }
  };

  const handleChangeLockStatus = async () => {
    setLoadingStatus(true);
    const resp = await changeLockStatus(selectedQuarterID);

    if (resp.status === 201) {
      notif("Успешно промењен статус закључавања квартала", "success");
      getCurentQuarters();
      setSelectedQuarterID("");
    } else {
      notif("Грешка при промени статуса закључавања квартала", "error");
      setSelectedQuarterID("");
    }
  };

  useEffect(() => {
    setLoading(true);
    getAvailableQuarters();
    getCurentQuarters();
    setLoading(false);
  }, [tabValue, historyPage, historyPageSize]);

  const handleSave = () => {
    selectedQuarterID ? handleChangeLockStatus() : createNewQuarter();
    setConfirmModalOpen(false);
  };
  const setPageAndCall = (newPage: number) => {
    setHistoryPage(newPage);
  };

  const columns = React.useMemo<GridColDef[]>(
    () => [
      { field: "quarter", headerName: "Квартал извештавања", flex: 1 },
      {
        field: "createdAt",
        headerName: "Датум започињања извештавања",
        flex: 1,
        valueFormatter: (params) => {
          if (!params.value) return "";
          const date = new Date(params.value);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        },
      },
      {
        field: "status",
        headerName: "Статус извештавања (Откључано/Закључано)",
        flex: 1,
        valueFormatter: (params) => {
          return params.value ? "Откључано" : "Закључано";
        },
      },
      { field: "createdBy", headerName: "Корисник", flex: 0.8, maxWidth: 160 },
      {
        field: "actions",
        headerName: "Aкције",
        flex: 0.5,
        minWidth: 100,
        sortable: false,
        renderCell: (params) => {
          return (
            <div className="flex flex-row gap-6 items-center">
              <Tooltip title={params.row.status ? "Закључај" : "Откључај"}>
                <div
                  className="flex items-center justify-center h-full"
                  onClick={() => {
                    setDialogTitle(
                      params.row.status
                        ? "Закључавање квартала за извештавање"
                        : "Откључавање квартала за извештавање",
                    );
                    setDialogContent(
                      `Да ли сте сигурни да желите да ${
                        params.row.status ? "закључате" : "откључате"
                      } квартал за извештавање: ${params.row.quarter}?`,
                    );
                    setDialogSubText(
                      params.row.status
                        ? "Закључавањем квартала за извештавање, више нећете моћи да мењате податке у вези са овим кварталом."
                        : "Откључавањем квартала за извештавање, моћи ћете поново да мењате податке у вези са овим кварталом.",
                    );
                    setSelectedQuarterID(params.row.id);
                    setConfirmModalOpen(true);
                  }}
                >
                  {params.row.status ? (
                    <FaLockOpen className="text-green-600 text-xl cursor-pointer" />
                  ) : (
                    <FaLock className="text-red-600 text-xl cursor-pointer" />
                  )}
                </div>
              </Tooltip>
              <Tooltip title="Иди на">
                <div>
                  <div
                    className="flex flex-col items-center justify-center"
                    onClick={() => {
                      navigate(
                        "/reporting/" +
                          (tabValue === 0 ? "national" : "measures") +
                          "/" +
                          params.row.id,
                      );
                    }}
                  >
                    <FaArrowRight className="text-gray-400 text-lg cursor-pointer" />
                  </div>
                </div>
              </Tooltip>
            </div>
          );
        },
      },
    ],
    [tabValue],
  );
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setSelectedQuarter("");
  };

  return (
    <div className="py-10 px-2 overflow-auto gray-small-scroll h-full w-full">
      <div className="flex gap-6 justify-between pr-10">
        <h1 className="text-[#04438b] text-4xl font-bold">
          Конфигурација извештавања
        </h1>
        <HelpButton onClick={() => setHelpModal(true)} />
      </div>
      <div className="rounded-lg border border-[#81848f3d] p-8 pb-4 mt-8 gap-2 w-full">
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            sx={{
              "& .MuiTabs-scroller": {
                overflowX: "hidden",
                "&:hover": {
                  overflowX: "auto !important",
                },
              },
            }}
          >
            <Tab label="Прописи" {...a11yProps(0)} />
            <Tab label="Мере" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <p className="text-[#404040] text-base mt-8">
          Одаберите квартал за извештавање {tabValue === 0 ? "прописа" : "мера"}
          :
        </p>
        <div className="flex flex-row gap-2 mt-2">
          <FormControl size="small" variant="outlined">
            <InputLabel id="quarters-label">Квартали</InputLabel>
            <Select
              disabled={availableQuarters.length === 0}
              labelId="quarters-label"
              value={selectedQuarter}
              label="Могући квартали"
              sx={{ minWidth: 120 }}
              onChange={(e) => {
                setSelectedQuarter(e.target.value);
              }}
              inputProps={{
                name: "quarters",
                id: "quarters",
              }}
            >
              {availableQuarters.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="w-full flex mt-12 items-center">
          <Button
            disabled={!selectedQuarter}
            variant="contained"
            sx={{ backgroundColor: "#0F2765" }}
            endIcon={<FaSave />}
            onClick={() => {
              setConfirmModalOpen(true);
              setDialogTitle("Додавање новог квартала за извештавање");
              setDialogContent(
                `Да ли сте сигурни да желите да додате нови квартал за извештавање ${
                  tabValue === 0 ? "прописа" : "мера"
                }: ${selectedQuarter}?`,
              );
              setDialogSubText(
                "Додавањем новог квартала за извештавање, претходни квартали ће бити закључани за измене података.",
              );
            }}
          >
            Потврди
          </Button>
        </div>

        <Dialog
          open={confirmModalOpen}
          onClose={() => setConfirmModalOpen(false)}
        >
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent style={{ paddingRight: "20px", paddingLeft: "20px" }}>
            <p>{dialogContent}</p>
            <p className="mt-2">{dialogSubText}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmModalOpen(false)}>Откажи</Button>
            <Button onClick={handleSave} variant="contained" color="primary">
              Потврди
            </Button>
          </DialogActions>
        </Dialog>

        <div className="mt-8">
          <h2 className="text-[#404040] text-2xl font-bold mb-2">
            Извештаји - {tabValue === 0 ? "Прописи" : "Мере"}
          </h2>
          <DataGrid
            rowCount={historyRowCount}
            loading={loading}
            pagination
            disableColumnMenu
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageAndCall(newPage);
            }}
            onPageSizeChange={(newPageSize) => setHistoryPageSize(newPageSize)}
            page={historyPage}
            pageSize={historyPageSize}
            rows={editingLockHistory}
            columns={columns}
            autoHeight={true}
            getRowHeight={() => 40}
            style={{ zIndex: 0 }}
            rowsPerPageOptions={[5, 10, 15]}
            disableSelectionOnClick
            components={{
              NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  Нема података за приказ
                </Stack>
              ),
              NoResultsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  Нема података за приказ
                </Stack>
              ),
            }}
          />
        </div>
      </div>
      <HelpPageModal
        modalIsOpen={helpModal}
        closeModal={() => setHelpModal(false)}
        name={"reportingConfig"}
      />
    </div>
  );
};

export default ReportingConfig;
